<section class="cmn-innerpage-wrapper quotation">
  <div class="main-wrapper">
    <div class="head-container">
      <div class="flex-wrapper">
        <div class="leftContainer">
          <div>
            <h6>Order Code</h6>
            <h5>{{ orderData?.orderCode || '--'}}</h5>
          </div>
          <div>
            <h6>Customer Name</h6>
            <h5>
              {{
                 orderData?.customerData ?
                orderData?.customerData?.firstName +
                  " " +
                  orderData?.customerData?.lastName : '--'
              }}
            </h5>
          </div>
          <div>
            <h6>Quote Id</h6>
            <h5>{{ orderData?.quoteData?.quoteCode || '--' }}</h5>
          </div>
          <div>
            <h6>Total Amount</h6>
            <h5>AED {{ orderData?.totalAmount | number: "1.2-2" }}</h5>
          </div>
          <div>
            <h6>Balance</h6>
            <h5>AED {{ orderData?.balance | number: "1.2-2" }}</h5>
          </div>
        </div>
        <div class="rightContainer">
          <div class="statusWrapper">
            <h6>
              Expected Date :
              <span class="">
                &nbsp; {{ orderData?.orderDate | date : "dd/MM/yyyy" }}</span
              >
            </h6>
            <h6>
              Status :
              <span class="status-inProgress">
                &nbsp; {{ orderData?.status === 'OnHold' ? 'On Hold' : orderData?.status || '--' }}</span
              >
            </h6>
            <h6>
              Priority :
              <span class="P-High"> &nbsp; {{ orderData?.priority || '--' }}</span>
            </h6>
          </div>
          <div class="actionWrapper">
            <div [matMenuTriggerFor]="menuHead" #menuTrigger>
              <mat-menu #menuHead="matMenu">
                <button mat-menu-item (click)="onStatusChange('OnHold')">On Hold</button>
                <button mat-menu-item (click)="onStatusChange('Cancelled')">Cancelled</button>
                <button mat-menu-item (click)="onStatusChange('Reopened')">Reopened</button>
              </mat-menu>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="4"
                height="23"
                viewBox="0 0 4 23"
                fill="none"
              >
                <g opacity="0.6">
                  <circle cx="2" cy="2" r="2" fill="black" />
                  <circle cx="2" cy="11.3333" r="2" fill="black" />
                  <circle cx="2" cy="20.6667" r="2" fill="black" />
                </g>
              </svg>
            </div>

            <div (click)="openDialog()" *ngIf="canTimelineSalesOrder$ | async">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
              >
                <g clip-path="url(#clip0_12_2730)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M25.0729 14.5C25.0779 16.8623 24.287 19.1575 22.8278 21.0153L21.1458 19.3333L19.9375 20.5417V25.9792H25.375L26.5833 24.7708L24.9763 23.1638C26.9961 20.729 28.0991 17.6635 28.0938 14.5C28.0938 6.99263 22.0074 0.90625 14.5 0.90625C6.99263 0.90625 0.90625 6.99263 0.90625 14.5C0.90625 22.0074 6.99263 28.0938 14.5 28.0938C15.4304 28.0921 16.3363 28.0015 17.2175 27.8219L16.6158 24.8615C14.4781 25.2981 12.2577 25.0627 10.2591 24.1875C8.26047 23.3124 6.58155 21.8403 5.45258 19.9733C4.32361 18.1063 3.79988 15.9357 3.95323 13.7593C4.10658 11.5829 4.92949 9.50718 6.3091 7.81691C7.68872 6.12665 9.55746 4.90458 11.659 4.31832C13.7606 3.73206 15.9921 3.81033 18.0475 4.54238C20.1028 5.27443 21.8813 6.62441 23.1391 8.40718C24.3969 10.1899 25.0724 12.3182 25.0729 14.5ZM15.7083 7.85417V15.1042L15.225 15.4667L10.3917 19.0917L8.94167 17.1583L13.2917 13.8958V7.85417H15.7083Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_12_2730">
                    <rect width="29" height="29" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ongoingTaskWrapper">
      <h6>Ongoing Tasks</h6>

      <!-- <div class="warningWrapper">
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clip-path="url(#clip0_116_663)">
              <mask
                id="mask0_116_663"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="14"
                height="14"
              >
                <path
                  d="M6.99996 12.8333C7.76615 12.8342 8.52496 12.6838 9.23282 12.3906C9.94068 12.0974 10.5836 11.6672 11.1247 11.1247C11.6672 10.5836 12.0974 9.94068 12.3906 9.23282C12.6838 8.52496 12.8342 7.76615 12.8333 6.99996C12.8342 6.23378 12.6838 5.47496 12.3906 4.76711C12.0974 4.05925 11.6672 3.41631 11.1247 2.87521C10.5836 2.33276 9.94068 1.90257 9.23282 1.60936C8.52496 1.31614 7.76615 1.16569 6.99996 1.16663C6.23378 1.16569 5.47496 1.31614 4.76711 1.60936C4.05925 1.90257 3.41631 2.33276 2.87521 2.87521C2.33276 3.41631 1.90257 4.05925 1.60936 4.76711C1.31614 5.47496 1.16569 6.23378 1.16663 6.99996C1.16569 7.76615 1.31614 8.52496 1.60936 9.23282C1.90257 9.94068 2.33276 10.5836 2.87521 11.1247C3.41631 11.6672 4.05925 12.0974 4.76711 12.3906C5.47496 12.6838 6.23378 12.8342 6.99996 12.8333Z"
                  fill="white"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.99992 10.7916C7.19331 10.7916 7.37877 10.7148 7.51552 10.578C7.65226 10.4413 7.72909 10.2558 7.72909 10.0624C7.72909 9.86903 7.65226 9.68356 7.51552 9.54682C7.37877 9.41007 7.19331 9.33325 6.99992 9.33325C6.80653 9.33325 6.62107 9.41007 6.48432 9.54682C6.34757 9.68356 6.27075 9.86903 6.27075 10.0624C6.27075 10.2558 6.34757 10.4413 6.48432 10.578C6.62107 10.7148 6.80653 10.7916 6.99992 10.7916Z"
                  fill="black"
                />
                <path
                  d="M7 3.5V8.16667"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </mask>
              <g mask="url(#mask0_116_663)">
                <path d="M0 0H14V14H0V0Z" fill="white" />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_116_663">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <span> This is the warning message text </span>
      </div> -->

      <div class="tableWrapper">
        <table>
          <thead>
            <tr>
              <td>Task Name</td>
              <td>Assigned To</td>
              <td>Delivery Date</td>
              <td>Status</td>
            </tr>
          </thead>
          <tbody *ngIf="inProgressData?.length > 0; else noData">
            <tr *ngFor="let inProgress of inProgressData">
              <td>
                {{ inProgress?.serviceTaskData?.taskData?.taskName || "--" }}
              </td>
              <td>
                {{
                  inProgress?.employeeData ? 
                  inProgress?.employeeData?.firstName +
                    " " +
                    inProgress?.employeeData?.lastName : '--'
                }}
              </td>
              <td>{{ inProgress?.deadline | date : "dd/MM/yyyy" }}</td>
              <td class="status-pending">
                {{ inProgress?.serviceTaskStatus || "--" }}
              </td>
            </tr>
          </tbody>
          <ng-template #noData>
            <tr>
              <td colspan="4" class="no-data" style="text-align: center">
                No data available
              </td>
            </tr>
          </ng-template>
        </table>
      </div>
    </div>

    <div class="dropdown-list">
      <div class="dropdown-item">
        <mat-accordion multi *ngIf="orderServiceData?.length > 0; else noData">
          <mat-expansion-panel *ngFor="let order of orderServiceData">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h5 class="title-text">
                  {{ order?.serviceData?.serviceName || "--" }}
                </h5>
              </mat-panel-title>
              <mat-panel-description
                ><h6 class="task-status-text status-inProgress">
                  {{ order?.serviceStatus || "--" }}
                </h6>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="tableWrapper">
              <table>
                <thead>
                  <tr>
                    <td>Task Name</td>
                    <td>Assigned To</td>
                    <td>Delivery Date</td>
                    <td>Status</td>
                    <td>Action</td>
                  </tr>
                </thead>

                <tbody
                  *ngIf="order?.serviceTaskAssignments?.length > 0; else noData"
                >
                  <tr *ngFor="let tasks of order?.serviceTaskAssignments">
                    <td>
                      {{ tasks?.serviceTaskData?.taskData?.taskName || "--" }}
                    </td>
                    <td>
                      {{
                        tasks?.employeeData
                          ? tasks?.employeeData?.firstName +
                            " " +
                            tasks?.employeeData?.lastName
                          : "--"
                      }}
                    </td>
                    <td>{{ tasks?.deadline | date : "dd/MM/yyyy" }}</td>
                    <td class="status-inProgress">
                      {{ tasks?.serviceTaskStatus || "--" }}
                    </td>
                    <td *ngIf="tasks?.serviceTaskStatus !== 'Completed'">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="4"
                        height="23"
                        viewBox="0 0 4 23"
                        fill="none"
                        [matMenuTriggerFor]="menu"
                        #menuTrigger
                        *ngIf="(canCompletedSalesOrder$ | async) || (canUnassignSalesOrder$ | async) || (canAssignReassignSalesOrder$ | async)"
                      >
                        <g opacity="0.6">
                          <circle cx="2" cy="2" r="2" fill="black" />
                          <circle cx="2" cy="11.3333" r="2" fill="black" />
                          <circle cx="2" cy="20.6667" r="2" fill="black" />
                        </g>
                      </svg>
                      <mat-menu #menu="matMenu">
                        <button
                          mat-menu-item
                          *ngIf="
                            tasks?.serviceTaskStatus !== 'Review' &&
                            tasks?.serviceTaskStatus !== 'Completed' &&
                            (canAssignReassignSalesOrder$ | async)
                          "
                          (click)="openDialogAssignee(tasks?.id)"
                        >
                          Assign / Reassign
                        </button>
                        <button
                          mat-menu-item
                          *ngIf="
                            tasks?.serviceTaskStatus !== 'Review' &&
                            tasks?.serviceTaskStatus !== 'Completed' &&
                            (canUnassignSalesOrder$ | async)
                          "
                          (click)="onUnassign(tasks?.id)"
                        >
                          Unassign
                        </button>
                        <button
                          mat-menu-item
                          *ngIf="tasks?.serviceTaskStatus === 'Review' && (canCompletedSalesOrder$ | async)"
                          (click)="markAsTaskCompleted(tasks?.id)"
                        >
                          Mark as completed
                        </button>
                      </mat-menu>
                    </td>
                  </tr>
                  <ng-template #noData>
                    <tr>
                      <td
                        colspan="4"
                        class="no-data"
                        style="text-align: center"
                      >
                        No data available
                      </td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>

            <div
              class="btnWrapper"
              *ngIf="
                allTasksCompleted(order) && order?.serviceStatus !== 'Completed' && (canCompletedSalesOrder$ | async)
              "
            >
              <button
                class="cmn-add-btn"
                (click)="markServiceAsCompleted(order?.id)"
              >
                Mark As Complete
              </button>
            </div>
            <!-- <div class="btnWrapper" *ngIf="order?.serviceTaskStatus !== 'Completed'">
              <button class="cmn-add-btn" (click)="markServiceAsCompleted(order?.id)">Mark As Complete</button>
            </div> -->
          </mat-expansion-panel>
        </mat-accordion>
        <ng-template #noData>
          <div class="no-data">No data found.</div>
        </ng-template>
      </div>

      <div class="btnWrapper" *ngIf="allServicesCompleted(orderServiceData) && orderData?.status !== 'Completed'">
        <button class="cmn-add-btn" (click)="markAllServiceAsCompleted()">
          Mark All As Complete
        </button>
      </div>
    </div>
  </div>
</section>
